module.exports = __webpack_public_path__ + "img/curved-rail-vertical-right-bottom-metals-remnants.42b14173.png";